//#region src/version.ts
const VERSION = "2.10.0";
//#endregion
export { VERSION };

//# sourceMappingURL=version.js.map